export const VIEW_DETAILS = 'viewDetails';
export const REPORT_ISSUE = 'reportIssue';
export const EXPORT_CUSTOM_SRT = 'exportCustomSrt';
export const EXPORT_SOURCE_CUSTOM_SRT = 'exportSourceCustomSrt';
export const EXPORT_LOW_QUALITY_VIDEO = 'exportLowQualityVideo';
